import React, {useLayoutEffect} from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import {addLicense, getPieChart, setChartColor} from "./commons";


function DonutChart({
    id,
    data,
    minHeight = "350px",
    minWidth = "350px",
    legend = true,
    legendPosition = "left",
    extraOptions = {},
    showPercentages = true,
    showPercentagesInTooltip = true,
    formatNumber,
    uom="",
    otherValueField=null
}) {

  useLayoutEffect(() => {

    addLicense();

    let root = am5.Root.new(id);
    root.setThemes([am5themes_Animated.new(root)])
    root.dateFormatter.set("dateFormat", "dd/MM/yyyy")
    if (!!formatNumber) {
      root.numberFormatter.set("numberFormat", formatNumber)
    }
    // Create chart
    let chart = getPieChart(root, {
      ...extraOptions,
      layout: legendPosition === "bottom" ? root.verticalLayout : root.horizontalLayout,
    });
    let otherValueStringInLegend =
      otherValueField ? ` {${otherValueField}}` : "";
    // Add series
    let series = chart.series.push(am5percent.PieSeries.new(root, {
      valueField: "value",
      ...(otherValueField? {customValue: otherValueField}: {}),
      categoryField: "category",
      ...(legend && !showPercentages
          ? {
            legendLabelText: "{category}:",
            legendValueText: otherValueStringInLegend ? otherValueStringInLegend: ("{value}" + uom),
          }
        : {}
      ),
    }))

    series.slices.template.set("toggleKey", "none");

    // Disabling labels and ticks
    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    if (!showPercentages) {
      series.labels.template.set("text", "{category}: {value}");
      if (!showPercentagesInTooltip)
        series.slices.template.set("tooltipText", "{category}: {value}");
    }

    setChartColor(series)

    series.data.setAll(data)

    if (legend) {
      let legend = chart.children.push(am5.Legend.new(root, {
        ...(legendPosition === "bottom"
          ? {centerX: am5.percent(50), x: am5.percent(50)}
          : {centerY: am5.percent(50), y: am5.percent(50)}
        ),
        marginTop: 15,
        marginBottom: 15,
        layout: legendPosition === "bottom" ? root.gridLayout : root.verticalLayout,
      }));

      legend.data.setAll(series.dataItems);
    }

    // Make stuff animate on load
    series.appear(1000)

    return () => {
      root.dispose()
    }
  }, [data, id, otherValueField]) // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} style={{ minHeight, minWidth }}/>
}

export default React.memo(DonutChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data) && _.isEqual(props.legend, nextProps.legend) && _.isEqual(props.otherValueField, nextProps.otherValueField)
})
